// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iOx0","badges":"styles_badges__2JK4D"};